/**
 * Custom error type denoting a network request failed because it reached the maximum wait time without returning a
 * response. TimeoutError is an specialization of the built-in Error type.
 * @param {String} message - The message the error will show in the console if it's not caught
 * @constructor
 */
function TimeoutError(message) {
  this.message = message;
  this.name = "TimeoutError";
}

TimeoutError.prototype = new Error();

export { TimeoutError };
